/* House of Ovelle — Air offer lander (v1.7, 11 Oct 2026)
   Tier picker (solo / +1 / +2 / +2 with refills), scent slots, one
   /cart/add.js with the set, then /cart/update.js applies the tier's
   discount code (keeping any other code already in the bag), then either
   straight to /checkout (data-checkout="true") or the drawer re-renders.
   Plus: countdown (one deadline, three displays), the tap-to-play UGC
   carousel, and the phone sticky bar + countdown strip.

   v1.1 — empty scent slots, × to remove, tap-again to remove, notes as a
   bottom sheet opened by ⓘ, optional direct-to-checkout.
   v1.2 — no em dashes in visitor-facing strings.
   v1.3 — every tier's button reads "Checkout for $X"; the refill tier's
   free gift bottle is only added when the section's gift value is > 0
   (Marc, 29 Sep: the refill set is the Air + 2 bottles, nothing else).
   v1.4 — the theme no longer fires its own AddToCart / add_to_cart. Shopify's
   Facebook and Google channel pixels already emit those from the standard
   product_added_to_cart event (once per cart line), so the theme's extra
   fbq / gtag / dataLayer calls were adding a 4th Meta AddToCart and a 2nd
   and 3rd GA4 add_to_cart per set. UGC video posters now load only when a
   video is played (the lazy <img> already shows the same frame).
   v1.5 — "proof first" flow (root[data-flow="proof"], class .ovo--b), for the
   /pages/air-b split test: muted looping hero film with a loop-start, UGC
   cards that autoplay muted in view and go loud on tap (progress bar, pause
   on tap), the scent grid collapsed behind "Change scents", the countdown
   strip stepping behind the single sticky bar, fade-up reveals, and small
   GA4/dataLayer events (ovo_scroll 25/50/75/90, ovo_section, ovo_video
   start/complete) so scroll depth can be compared between the two pages.
   Everything new is a no-op on the classic flow except the events.
   v1.6 — value pass: refill switch (bottle 1 of a set on the monthly plan,
   data-refill default), honest anchor mode (value line per set tier, no
   strike on solo), settable set-tier names, delivery estimate + device-aware
   payment logos in the reassurance strip. All gated on the section's
   settings / data attributes, so a classic page renders as before. */
(function () {
  'use strict';

  function money(cents, fmt) {
    if (window.ovelleFormatMoney) return window.ovelleFormatMoney(cents, fmt, { trimZeros: true });
    var v = cents / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }
  function uid() { return 'A' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    if (root.__ovo) return;
    root.__ovo = true;
    var dataEl = root.querySelector('[data-ovo-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[ovo] bad data', e); return; }

    var cfg = {
      codes: { one: root.dataset.codeSet1 || '', two: root.dataset.codeSet2 || '', ritual: root.dataset.codeRitual || '' },
      /* v1.6.5: BXGY codes never count a subscription bottle, so a set with the
         refill switch on uses an order-level code instead (AIRSET1R / AIRSET2R). */
      refillCodes: { one: root.dataset.codeSet1Refill || '', two: root.dataset.codeSet2Refill || '' },
      giftCode: root.dataset.codeGift || '',
      ritualOff: +root.dataset.ritualOff || 0,
      giftValue: +root.dataset.giftValue || 0,
      set1Off: +root.dataset.set1Off || 0,
      set2Off: +root.dataset.set2Off || 0,
      /* v1.7: a set can carry a different $ off while the refill switch is on (Halo). */
      set1RefillOff: root.dataset.set1RefillOff ? +root.dataset.set1RefillOff : (+root.dataset.set1Off || 0),
      set2RefillOff: root.dataset.set2RefillOff ? +root.dataset.set2RefillOff : (+root.dataset.set2Off || 0),
      tierSoloName: root.dataset.tierSoloName || 'Ovelle Air solo',
      oilSize: root.dataset.oilSize || '120 ml',
      compare: +root.dataset.airCompare || 0,
      threshold: +root.dataset.threshold || 12000,
      flat: +root.dataset.flat || 0,
      edit: root.dataset.setEdit || location.pathname,
      ends: root.dataset.ends || '',
      checkout: root.dataset.checkout === 'true',
      prefill: root.dataset.prefill !== 'false',
      fmt: root.dataset.moneyFormat || '${{amount}}',
      anchor: root.dataset.anchor || 'compare',
      airPrice: +root.dataset.airPrice || 0,
      oilPrice: +root.dataset.oilPrice || 0,
      refillDefault: root.dataset.refill === 'true',
      refillPrice: +root.dataset.refillPrice || 0,
      shipLead: parseInt(root.dataset.shipLead, 10) || 1,
      daysPerBottle: parseInt(root.dataset.daysPerBottle, 10) || 0,
      transit: parseInt(root.dataset.transit, 10) || 0
    };
    var m = function (c) { return money(Math.round(c), cfg.fmt); };
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var proof = root.dataset.flow === 'proof';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- v1.5: light measurement (GA4 via gtag or dataLayer, plus Shopify's pixel bus) ---------- */
    function track(name, params) {
      try {
        var p = Object.assign({ flow: root.dataset.flow || 'classic', page: location.pathname }, params || {});
        /* v1.5.1: queue in gtag's own arguments form so events fired before
           Shopify's Google tag loads are replayed by it, not dropped. */
        window.dataLayer = window.dataLayer || [];
        if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('event', name, p);
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, p);
      } catch (e) {}
    }
    (function scrollDepth() {
      var marks = [25, 50, 75, 90], fired = {};
      function onScroll() {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight; if (max <= 0) return;
        var pct = Math.round((window.scrollY || doc.scrollTop) / max * 100);
        marks.forEach(function (mk) { if (!fired[mk] && pct >= mk) { fired[mk] = true; track('ovo_scroll', { depth: mk }); } });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(onScroll, 1500);
    })();
    if ('IntersectionObserver' in window) {
      var secs = [].slice.call(root.querySelectorAll(':scope > section, :scope > ul.ovo-trust'));
      var seen = {};
      var secIo = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var mt = /(?:^|\s)ovo-(?!sec\b|rv\b)([a-z]+)/.exec(e.target.className) || []; var nm = mt[1] || 'section';
          if (!seen[nm]) { seen[nm] = true; track('ovo_section', { section: nm }); }
          if (proof && !reduce) e.target.classList.add('is-in');
        });
      }, { threshold: 0.25 });
      secs.forEach(function (el) { if (proof && !reduce && !el.classList.contains('ovo-hero')) el.classList.add('ovo-rv'); secIo.observe(el); });
    }

    /* ---------- v1.5: hero film (muted loop over the still, loops from data-loop-start) ---------- */
    var film = root.querySelector('[data-ovo-hero-film]');
    if (film) {
      var filmBox = film.parentElement, loopStart = parseFloat(film.dataset.loopStart) || 0;
      if (reduce) { film.removeAttribute('autoplay'); film.pause(); }
      else {
        /* Speed (Oct 2026): pick exactly one file for this screen, then load it. */
        var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
        var filmSrc = (mq('(max-width: 749px)') && film.dataset.srcM) || (mq('(min-width: 990px)') && film.dataset.srcD) || film.dataset.src;
        if (filmSrc && !film.getAttribute('src')) { film.src = filmSrc; film.preload = 'auto'; }
        film.addEventListener('playing', function () { filmBox.classList.add('is-film'); }, { once: true });
        if (loopStart > 0) {
          film.removeAttribute('loop');
          film.addEventListener('ended', function () { film.currentTime = loopStart; film.play().catch(function () {}); });
        }
        film.play().catch(function () {});
      }
    }

    var oils = data.oils || [];
    var oilById = {};
    oils.forEach(function (o) { oilById[o.id] = o; });
    var oilByHandle = {};
    oils.forEach(function (o) { oilByHandle[o.handle] = o; });
    var variants = data.air.variants || [];
    var colors = [];
    variants.forEach(function (v) { if (colors.indexOf(v.color) < 0) colors.push(v.color); });

    var hasRitual = !!root.querySelector('[data-ovo-tier="ritual"]');
    var firstAvail = oils.filter(function (o) { return o.available; });
    var def = root.dataset.defaultTier || 'two';
    if (def === 'ritual' && !hasRitual) def = 'two';
    var pick = function (i) { if (!cfg.prefill) return null; var o = firstAvail[i] || oils[i]; return o ? o.id : null; };

    var hasRefill = oils.some(function (o) { return o.mplan; });
    var state = { tier: def, color: (variants.filter(function (v) { return v.available; })[0] || variants[0] || {}).color, scents: [pick(0), pick(1), null], slot: 0, busy: false, going: false, refill: hasRefill && cfg.refillDefault };
    var COUNT = { solo: 0, one: 1, two: 2, ritual: 2 };
    var NAMES = { solo: cfg.tierSoloName, one: root.dataset.tierOneName || 'Air + 1 fragrance', two: root.dataset.tierTwoName || 'Air + 2 fragrances', ritual: 'Air + 2 fragrances + refills' };
    /* v1.6: is scent slot i the refill bottle? (first slot of a set tier while the switch is on) */
    function isRefillSlot(tier, i) { return state.refill && i === 0 && (tier === 'one' || tier === 'two'); }
    var count = function () { return COUNT[state.tier]; };
    function chosen() { return state.scents.slice(0, count()); }
    function missing() { return chosen().filter(function (id) { return !id || !oilById[id]; }).length; }
    function firstEmpty() { return chosen().indexOf(null); }

    /* ---------- colours ---------- */
    var colorsEl = root.querySelector('[data-ovo-colors]');
    var colorWrap = root.querySelector('[data-ovo-colors-wrap]');
    var colorName = root.querySelector('[data-ovo-color-name]');
    function colorLabel(c) { return c === 'Default' ? '' : 'Matte ' + c; }
    function renderColors() {
      if (colors.length < 2) { colorWrap.hidden = true; return; }
      colorWrap.hidden = false;
      colorsEl.innerHTML = '';
      colors.forEach(function (c) {
        var v = variants.filter(function (x) { return x.color === c; })[0];
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', c === state.color ? 'true' : 'false');
        b.className = 'ovo-swatch ovo-swatch--' + c.toLowerCase().replace(/\s+/g, '-') + (c === state.color ? ' is-on' : '');
        b.textContent = colorLabel(c) + (v && !v.available ? ' (sold out)' : '');
        if (v && !v.available) b.disabled = true;
        b.addEventListener('click', function () { state.color = c; renderAll(); });
        colorsEl.appendChild(b);
      });
      if (colorName) colorName.textContent = '· ' + colorLabel(state.color);
    }

    /* ---------- scents: slots + tiles ---------- */
    var scentsWrap = root.querySelector('[data-ovo-scents-wrap]');
    var slotsEl = root.querySelector('[data-ovo-slots]');
    var hintEl = root.querySelector('[data-ovo-hint]');
    var tiles = [].slice.call(root.querySelectorAll('[data-ovo-oil]'));
    /* v1.5: in the proof flow the grid starts collapsed behind the two chosen chips */
    var scentsToggle = root.querySelector('[data-ovo-scents-toggle]');
    function openScents(open) {
      if (!scentsToggle) return;
      scentsWrap.classList.toggle('is-collapsed', !open);
      scentsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      scentsToggle.textContent = open ? 'Done' : 'Change scents';
    }
    if (scentsToggle) scentsToggle.addEventListener('click', function () { openScents(scentsWrap.classList.contains('is-collapsed')); });
    function renderScents() {
      var n = count();
      scentsWrap.hidden = n === 0;
      if (n === 0) return;
      if (state.slot >= n) state.slot = 0;
      var picked = chosen();
      slotsEl.innerHTML = '';
      picked.forEach(function (id, i) {
        var o = id ? oilById[id] : null;
        var on = n > 1 && i === state.slot;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ovo-slot' + (on ? ' is-on' : '') + (o ? '' : ' is-empty');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = n === 1 ? 'Your scent' : 'Scent ' + (i + 1);
        if (o) {
          b.innerHTML = '<img alt="" width="36" height="46"><span><span class="ovo-slot__k"></span><span class="ovo-slot__v"></span></span><span class="ovo-slot__x" role="button" tabindex="0" data-ovo-clear aria-label="Remove this scent">×</span>';
          b.querySelector('img').src = o.img;
          b.querySelector('.ovo-slot__k').textContent = label;
          b.querySelector('.ovo-slot__v').textContent = o.title;
          var x = b.querySelector('[data-ovo-clear]');
          function clear(e) { e.preventDefault(); e.stopPropagation(); state.scents[i] = null; state.slot = i; renderScents(); renderPrices(); }
          x.addEventListener('click', clear);
          x.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') clear(e); });
        } else {
          b.innerHTML = '<span class="ovo-slot__plus" aria-hidden="true">+</span><span><span class="ovo-slot__k"></span><span class="ovo-slot__v"></span></span>';
          b.querySelector('.ovo-slot__k').textContent = label;
          b.querySelector('.ovo-slot__v').textContent = on || n === 1 ? 'Tap a scent below' : 'Choose a scent';
        }
        b.addEventListener('click', function () { state.slot = i; renderScents(); openScents(true); });
        slotsEl.appendChild(b);
      });
      var need = missing();
      hintEl.textContent = n > 1
        ? (need ? 'Tap a scent to fill the highlighted slot. ' : 'Both chosen. ') + 'Tap × on a slot, or a chosen scent again, to swap it.'
        : (need ? 'Tap a scent to choose it. ' : '') + 'Tap it again to remove it.';
      hintEl.textContent += ' ⓘ shows the notes.';
      tiles.forEach(function (t) {
        var id = +t.dataset.ovoOil;
        var idxs = [];
        picked.forEach(function (p, i) { if (p === id) idxs.push(i + 1); });
        t.classList.toggle('is-on', idxs.length > 0);
        t.setAttribute('aria-pressed', idxs.length ? 'true' : 'false');
        var badge = t.querySelector('.ovo-tile__badge');
        if (badge) badge.textContent = idxs.length ? (n > 1 ? idxs.join('·') : '✓') : '';
      });
    }
    function chooseOil(id) {
      var n = count();
      if (n === 0) { state.tier = 'one'; n = 1; }
      var picked = chosen();
      var at = picked.indexOf(id);
      if (at >= 0) {
        state.scents[at] = null;
        state.slot = at;
      } else {
        var slot = state.slot < n && !state.scents[state.slot] ? state.slot : picked.indexOf(null);
        if (slot < 0) slot = state.slot < n ? state.slot : 0;
        state.scents[slot] = id;
        var e = firstEmpty();
        state.slot = e >= 0 ? e : (slot + 1) % n;
      }
      renderScents(); renderPrices();
    }
    tiles.forEach(function (t) { t.addEventListener('click', function () { var o = oilById[+t.dataset.ovoOil]; chooseOil(+t.dataset.ovoOil); track('ovo_scent', { scent: o ? o.handle : String(t.dataset.ovoOil), picked: chosen().indexOf(+t.dataset.ovoOil) >= 0 }); }); });

    /* ---------- scent notes sheet (ⓘ on a tile) ---------- */
    var sheet = root.querySelector('[data-ovo-sheet]');
    var sc = root.querySelector('[data-ovo-scent-card]');
    var scPick = root.querySelector('[data-ovo-sc-pick]');
    var scId = null;
    function fillPick() {
      if (!scPick || !scId) return;
      scPick.textContent = chosen().indexOf(scId) >= 0 ? 'Remove from my set' : (count() === 0 ? 'Add this scent' : 'Choose this scent');
    }
    function showScent(id) {
      var o = oilById[id]; if (!sc || !o) return;
      scId = id;
      sc.querySelector('[data-ovo-sc-img]').src = o.img;
      sc.querySelector('[data-ovo-sc-mood]').textContent = o.mood || '';
      sc.querySelector('[data-ovo-sc-name]').textContent = o.title;
      sc.querySelector('[data-ovo-sc-desc]').textContent = o.desc || o.notes || '';
      var dl = sc.querySelector('[data-ovo-sc-notes]'); dl.innerHTML = '';
      [['Top', o.top], ['Heart', o.heart], ['Base', o.base]].forEach(function (r) {
        if (!r[1]) return;
        var dt = document.createElement('dt'); dt.textContent = r[0];
        var dd = document.createElement('dd'); dd.textContent = r[1];
        dl.appendChild(dt); dl.appendChild(dd);
      });
      sc.querySelector('[data-ovo-sc-best]').textContent = (o.best ? 'Best for: ' + o.best : '') + (o.inspired ? (o.best ? ' · ' : '') + '“' + o.inspired + '”' : '');
      sc.style.setProperty('--ovo-sc-accent', o.accent || 'var(--ovo-champ)');
      fillPick();
      if (sheet) { sheet.hidden = false; sheet.classList.add('is-open'); }
      var cl = sc.querySelector('[data-ovo-sc-close]'); if (cl) cl.focus({ preventScroll: true });
    }
    function hideScent() { if (sheet) { sheet.classList.remove('is-open'); sheet.hidden = true; } scId = null; }
    root.querySelectorAll('[data-ovo-info]').forEach(function (i) {
      function go(e) { e.preventDefault(); e.stopPropagation(); showScent(+i.dataset.ovoInfo); }
      i.addEventListener('click', go);
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    });
    root.querySelectorAll('[data-ovo-sc-close]').forEach(function (b) { b.addEventListener('click', hideScent); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) hideScent(); });
    if (scPick) scPick.addEventListener('click', function () { if (scId) chooseOil(scId); hideScent(); });
    root.querySelectorAll('[data-ovo-pick-scent]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var o = oilByHandle[a.dataset.ovoPickScent];
        if (!o) return;
        e.preventDefault();
        if (chosen().indexOf(o.id) < 0) chooseOil(o.id);
        var t = root.querySelector('[data-ovo-oil="' + o.id + '"]');
        if (t) { t.classList.add('is-flash'); setTimeout(function () { t.classList.remove('is-flash'); }, 1400); }
        document.getElementById('ovo-offers').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ---------- v2.3 gift finder: tiles switch the card, its button fills the offer with that person's scents ---------- */
    root.querySelectorAll('[data-ovo-gf]').forEach(function (gf) {
      var gTiles = [].slice.call(gf.querySelectorAll('[data-ovo-gf-tile]'));
      var gCards = [].slice.call(gf.querySelectorAll('[data-ovo-gf-card]'));
      function gShow(i, focusCard) {
        gTiles.forEach(function (t, j) { t.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        gCards.forEach(function (c, j) { c.hidden = j !== i; });
        if (focusCard && gCards[i] && window.innerWidth < 990) {
          var r = gCards[i].getBoundingClientRect();
          if (r.top > window.innerHeight * 0.6) gCards[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      gTiles.forEach(function (t, i) {
        t.addEventListener('click', function () {
          gShow(i, true);
          var lab = t.textContent.trim();
          track('ovo_gift_person', { who: lab });
        });
      });
      document.addEventListener('shopify:block:select', function (e) {
        var id = e.detail && e.detail.blockId; if (!id) return;
        gCards.forEach(function (c, j) { if (c.dataset.ovoGfCard === id) gShow(j); });
      });
    });
    root.querySelectorAll('[data-ovo-gift-scents]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var ids = (a.dataset.ovoGiftScents || '').split(',').map(function (h) { var o = oilByHandle[h.trim()]; return o && o.available !== false ? o.id : null; }).filter(function (x) { return x; });
        e.preventDefault();
        if (ids.length) {
          state.scents[0] = ids[0];
          if (ids[1]) state.scents[1] = ids[1];
          var want = ids.length > 1 ? 'two' : 'one';
          if (root.querySelector('[data-ovo-tier="' + want + '"]')) selectTier(want); else { renderScents(); renderPrices(); }
          ids.forEach(function (id) {
            var t = root.querySelector('[data-ovo-oil="' + id + '"]');
            if (t) { t.classList.add('is-flash'); setTimeout(function () { t.classList.remove('is-flash'); }, 1400); }
          });
        }
        track('ovo_gift_set', { who: a.dataset.ovoGiftWho || '', scents: a.dataset.ovoGiftScents || '' });
        var off = document.getElementById('ovo-offers');
        if (off) off.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ---------- prices ---------- */
    var cards = [].slice.call(root.querySelectorAll('[data-ovo-tier]'));
    var addBtn = root.querySelector('[data-ovo-add]');
    var summaryEl = root.querySelector('[data-ovo-summary]');
    var subEl = root.querySelector('[data-ovo-sub]');
    var deadlineEl = root.querySelector('[data-ovo-deadline]');
    var errEl = root.querySelector('[data-ovo-error]');
    var instOn = !!root.querySelector('[data-ovo-installments]');
    var instMain = root.querySelector('[data-ovo-inst-main]');
    var termsForm = root.querySelector('[data-ovo-terms]');
    function airVariant() { return variants.filter(function (v) { return v.color === state.color; })[0] || variants[0]; }
    function quote(tier) {
      var av = airVariant();
      var compare = Math.max(cfg.compare, av.price);
      var n = COUNT[tier];
      var ids = state.scents.slice(0, n);
      var was = compare, now = av.price, renew = 0;
      var fallback = firstAvail[0] || oils[0];
      var honest = cfg.anchor === 'offer';
      if (honest) { was = av.price; }
      var bottlesFull = 0;
      ids.forEach(function (id, i) {
        var o = (id && oilById[id]) || fallback; if (!o) return;
        was += o.price; bottlesFull += o.price;
        if (tier === 'ritual' && o.plan) { now += o.plan.price; renew += o.plan.price; }
        else if (isRefillSlot(tier, i) && o.mplan) { now += o.mplan.price; renew += o.mplan.price; }
        else { now += o.price; }
      });
      if (tier === 'one') now -= (state.refill ? cfg.set1RefillOff : cfg.set1Off);
      if (tier === 'two') now -= (state.refill ? cfg.set2RefillOff : cfg.set2Off);
      if (tier === 'ritual') { now -= cfg.ritualOff; was += cfg.giftValue; }
      if (!honest && tier !== 'solo' && now >= cfg.threshold && cfg.flat) was += cfg.flat;
      if (honest && tier === 'solo') was = now;
      return { was: was, now: now, save: was - now, renew: renew, bottles: now - av.price, bottlesFull: bottlesFull, n: n };
    }
    function instText(cents) {
      if (!instOn || cents < 5000 || cents >= 100000) return '';
      return 'or 4 interest-free payments of ' + m(cents / 4) + ' with Shop Pay';
    }
    function shipText(q) {
      return q.now >= cfg.threshold ? 'Free US shipping' + (cfg.flat ? ' (' + m(cfg.flat) + ' value)' : '') : (cfg.flat ? '+ ' + m(cfg.flat) + ' shipping' : 'Shipping at checkout');
    }
    function renderPrices() {
      cards.forEach(function (c) {
        var t = c.dataset.ovoTier, q = quote(t), on = t === state.tier;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        var now = c.querySelector('[data-ovo-now]'); if (now) now.textContent = m(q.now);
        var was = c.querySelector('[data-ovo-was]'); if (was) { was.textContent = m(q.was); was.hidden = q.save <= 0; }
        var sv = c.querySelector('[data-ovo-save]'); if (sv) { sv.textContent = 'Save ' + m(q.save) + (t === 'ritual' ? ' today' : ''); sv.hidden = q.save <= 0; }
        var vl = c.querySelector('[data-ovo-value]'); if (vl && q.n > 0) vl.textContent = q.n + ' bottle' + (q.n > 1 ? 's' : '') + ' for ' + m(q.bottles) + ' instead of ' + m(q.bottlesFull);
        var dl = c.querySelector('[data-ovo-day]'); if (dl) dl.textContent = perDayLine(t, q);
        var sh = c.querySelector('[data-ovo-ship]'); if (sh) sh.textContent = shipText(q);
        var rn = c.querySelector('[data-ovo-renew]'); if (rn && q.renew) rn.textContent = m(q.renew);
        var ins = c.querySelector('[data-ovo-inst]'); if (ins) { var it = instText(q.now); ins.hidden = !it; ins.textContent = it; }
      });
      var q = quote(state.tier);
      var av = airVariant();
      var need = missing();
      var ok = av && av.available && !need && chosen().every(function (id) { return oilById[id] && oilById[id].available; });
      addBtn.disabled = !ok || state.busy || over;
      addBtn.textContent = state.going ? 'Opening checkout…' : state.busy ? 'Adding…' : over ? 'Offer ended'
        : need ? 'Choose ' + (need === count() ? need : need + ' more') + ' scent' + (need > 1 ? 's' : '') + ' to continue'
        : (!ok ? 'Unavailable' : (cfg.checkout ? 'Checkout for ' : 'Add to bag for ') + m(q.now));
      if (instMain) { var mt = instText(q.now); instMain.hidden = !mt; instMain.textContent = mt; }
      if (termsForm) termsForm.hidden = state.tier !== 'solo';
      var names = chosen().map(function (id) { return id && oilById[id] ? oilById[id].title : '…'; });
      summaryEl.textContent = NAMES[state.tier] + (colors.length > 1 ? ' · ' + colorLabel(state.color) : '') + (names.length ? ' · ' + names.join(' · ') : '');
      renderRefill(q);
      renderDaily();
      if (warrantyEl) warrantyEl.textContent = (state.tier === 'ritual' ? '2-year' : '1-year') + ' warranty';
      subEl.textContent = (q.now >= cfg.threshold ? 'Free US shipping' : 'Add a scent for free shipping') + ' · Free 30-day returns · ' + (state.tier === 'ritual' ? '2-year' : '1-year') + ' warranty';
      stickyName.textContent = NAMES[state.tier];
      stickyPrice.textContent = m(q.now);
      stripPrice.textContent = m(q.now);
      fillPick();
      /* v2.5: the kit builder (assets/ovelle-air-kit.js) repaints on this. */
      try { root.dispatchEvent(new CustomEvent('ovo:change')); } catch (e) {}
    }
    /* ---------- v1.7: cost per day ---------- */
    function cents(c) { c = Math.round(c); return c < 100 ? c + '¢' : m(c); }
    function refillPerDay() {
      if (!cfg.daysPerBottle) return 0;
      var first = oilById[state.scents[0]] || firstAvail[0] || oils[0];
      var mp = first && first.mplan ? first.mplan.price : (first ? first.price : cfg.oilPrice);
      return mp / cfg.daysPerBottle;
    }
    function perDayLine(tier, q) {
      if (!cfg.daysPerBottle) return '';
      var r = refillPerDay();
      if (q.n === 0) return 'Bottles from ' + cents((cfg.oilPrice || 4900) / cfg.daysPerBottle) + ' a day, ' + cents(r) + ' on the refill plan';
      var days = q.n * cfg.daysPerBottle, months = Math.round(days / 30);
      return 'About ' + cents(q.now / days) + ' a day for the first ' + months + ' months, diffuser included. Then ' + cents(r) + ' a day on refills.';
    }
    function renderDaily() {
      var box = root.querySelector('[data-ovo-daily]'), hero = root.querySelector('[data-ovo-hero-perday]');
      if (!cfg.daysPerBottle) return;
      var r = refillPerDay(); var two = quote('two');
      if (box) {
        box.hidden = false;
        box.querySelector('[data-ovo-daily-refill]').textContent = cents(r);
        box.querySelector('[data-ovo-daily-first]').textContent = NAMES.two + ' is ' + m(two.now) + ' for about ' + Math.round(2 * cfg.daysPerBottle / 30) + ' months of scent, about ' + cents(two.now / (2 * cfg.daysPerBottle)) + ' a day with the diffuser included.';
      }
      if (hero) { hero.hidden = false; hero.textContent = 'From ' + cents(r) + ' a day once you have it. A ' + cfg.oilSize + ' bottle lasts about ' + Math.round(cfg.daysPerBottle / 30) + ' months on an evening schedule.'; }
    }

    /* ---------- v1.6: refill switch ---------- */
    var refillWrap = root.querySelector('[data-ovo-refill-wrap]');
    var refillBtn = root.querySelector('[data-ovo-refill]');
    var refillState = root.querySelector('[data-ovo-refill-state]');
    var refillCopy = root.querySelector('[data-ovo-refill-copy]');
    var warrantyEl = root.querySelector('[data-ovo-warranty]');
    function renderRefill(q) {
      if (!refillWrap) return;
      var setTier = state.tier === 'one' || state.tier === 'two';
      refillWrap.hidden = !setTier || !hasRefill;
      if (refillWrap.hidden) return;
      var first = oilById[state.scents[0]];
      var mp = first && first.mplan ? first.mplan.price : cfg.refillPrice;
      var full = first ? first.price : cfg.oilPrice;
      var pct = full ? Math.round((full - mp) / full * 100) : 0;
      refillBtn.classList.toggle('is-on', state.refill);
      refillBtn.setAttribute('aria-checked', state.refill ? 'true' : 'false');
      refillState.textContent = state.refill ? '· on' : '· off';
      refillCopy.textContent = state.refill
        ? 'A fresh bottle of ' + (first ? first.title : 'your first scent') + ' every month at ' + m(mp) + ' (' + pct + '% off). Nothing extra today: your first bottle is the one in this set, at the member price. Next one ships in 30 days. Skip, swap scents or cancel anytime.'
        : 'Buy bottles when you need them at ' + m(full) + '. Turn it on to get one a month at ' + m(mp) + ', skip or cancel anytime.';
    }
    if (refillBtn) refillBtn.addEventListener('click', function () { state.refill = !state.refill; renderPrices(); track('ovo_refill', { on: state.refill }); });

    /* ---------- v1.6: delivery estimate + device-aware payment logos ---------- */
    (function assure() {
      var arrive = root.querySelector('[data-ovo-arrive]');
      if (arrive && cfg.transit > 0) {
        var d = new Date(); var left = cfg.shipLead + cfg.transit;
        if (d.getHours() >= 14) left += 1; /* after the 2pm cut-off, ships next business day */
        while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) left--; }
        var fmt = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        arrive.textContent = 'Order today, arrives by ' + fmt;
      }
      var pay = root.querySelector('[data-ovo-pay]'); if (!pay) return;
      var ua = navigator.userAgent || '';
      var ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
      var safari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|Edg/.test(ua);
      var hasApple = !!window.ApplePaySession || (ios && safari);
      var android = /Android/.test(ua);
      var chrome = /Chrome|CriOS/.test(ua) && !/Edg/.test(ua);
      pay.querySelectorAll('[data-pay]').forEach(function (el) {
        var t = el.dataset.pay;
        if (t === 'apple_pay' && !hasApple) el.hidden = true;
        if (t === 'google_pay' && !(android || (chrome && !ios))) el.hidden = true;
      });
    })();

    cards.forEach(function (c) {
      c.addEventListener('click', function () { selectTier(c.dataset.ovoTier); track('ovo_tier', { tier: c.dataset.ovoTier, price: Math.round(quote(c.dataset.ovoTier).now) / 100 }); });
      c.addEventListener('keydown', function (e) {
        if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) < 0) return;
        e.preventDefault();
        var i = cards.indexOf(c) + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1);
        var next = cards[(i + cards.length) % cards.length];
        selectTier(next.dataset.ovoTier); next.focus();
      });
    });
    function selectTier(t) {
      state.tier = t;
      var e = firstEmpty();
      state.slot = e >= 0 ? e : 0;
      renderScents(); renderPrices();
      if (missing()) openScents(true);
    }

    /* ---------- add to bag ---------- */
    /* v1.6.2: read the bag once at load (warms the cart session so the first
       add is cheaper, and tells us which codes/tiers are already in it), so the
       checkout click is one request + the navigation instead of three. */
    var cartSnap = null;
    function snapCart() {
      return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { cartSnap = c; return c; }).catch(function () { return null; });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(function () { snapCart(); }); else setTimeout(snapCart, 800);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') snapCart(); });
    function tierCode(t, refill) {
      if (refill && cfg.refillCodes[t]) return cfg.refillCodes[t];
      return cfg.codes[t] || '';
    }
    function codesFor(cart) {
      var mine = [cfg.codes.one, cfg.codes.two, cfg.codes.ritual, cfg.refillCodes.one, cfg.refillCodes.two, cfg.giftCode].filter(Boolean).map(function (c) { return c.toUpperCase(); });
      var codes = ((cart && cart.discount_codes) || []).map(function (d) { return d.code; })
        .filter(function (c) { return mine.indexOf(String(c).toUpperCase()) < 0; });
      /* lines this page added before (and still in the bag) keep their own code */
      var tiersInBag = {};
      ((cart && cart.items) || []).forEach(function (it) {
        var pr = it.properties || {}; var lp = pr._ov_lp || '';
        if (lp.indexOf('air-') !== 0) return;
        var t = lp.slice(4); tiersInBag[t] = tiersInBag[t] || !!pr._ov_refill;
      });
      Object.keys(tiersInBag).forEach(function (t) {
        var c = tierCode(t, tiersInBag[t]); if (c && codes.indexOf(c) < 0) codes.push(c);
        if (t === 'ritual' && cfg.giftCode && codes.indexOf(cfg.giftCode) < 0) codes.push(cfg.giftCode);
      });
      return codes;
    }
    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) { var e = new Error(j.description || j.message || 'Something went wrong'); e.data = j; throw e; }
          return j;
        });
      });
    }
    function add() {
      if (state.busy || over || missing()) { if (missing()) { renderPrices(); openScents(true); scentsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } return; }
      var av = airVariant();
      var n = count();
      var ids = state.scents.slice(0, n);
      var setId = uid();
      var title = NAMES[state.tier];
      function props(role) { return { _ov_set: setId, _ov_set_role: role, _ov_set_title: title, _ov_set_edit: cfg.edit, _ov_lp: 'air-' + state.tier }; }
      var items = [{ id: av.id, quantity: 1, properties: props('diffuser') }];
      if (state.tier === 'ritual') {
        var subQty = {};
        ids.slice(0, 2).forEach(function (id) { subQty[id] = (subQty[id] || 0) + 1; });
        Object.keys(subQty).forEach(function (id) {
          var o = oilById[id];
          var it = { id: +id, quantity: subQty[id], properties: props('oil') };
          if (o.plan) it.selling_plan = o.plan.id;
          items.push(it);
        });
        /* optional free gift (gift-size bottle of scent 1), only when the section advertises one */
        if (cfg.giftValue > 0) {
          var g = oilById[ids[0]] && oilById[ids[0]].gift;
          if (g && g.available) { var gift = props('gift'); gift._ov_gift = 'Free gift'; items.push({ id: +g.id, quantity: 1, properties: gift }); }
        }
      } else {
        var qty = {};
        ids.forEach(function (id, i) {
          /* v1.6: the refill bottle is its own line on the monthly plan */
          if (isRefillSlot(state.tier, i) && oilById[id] && oilById[id].mplan) {
            var rp = props('oil'); rp._ov_refill = 'monthly';
            items.push({ id: +id, quantity: 1, selling_plan: oilById[id].mplan.id, properties: rp });
            return;
          }
          qty[id] = (qty[id] || 0) + 1;
        });
        Object.keys(qty).forEach(function (id) { items.push({ id: +id, quantity: qty[id], properties: props('oil') }); });
      }

      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (x) { return x.id; })
        : ['cart-drawer', 'cart-icon-bubble'];
      var want = [tierCode(state.tier, state.refill && (state.tier === 'one' || state.tier === 'two'))];
      if (state.tier === 'ritual' && cfg.giftCode) want.push(cfg.giftCode);
      want = want.filter(Boolean);

      state.busy = true; errEl.hidden = true;
      if (cfg.checkout) state.going = true;
      renderPrices();
      track('ovo_checkout', { tier: state.tier, refill: state.refill && state.tier !== 'solo', scents: ids.map(function (id) { return oilById[id] ? oilById[id].handle : ''; }).join(','), total: Math.round(quote(state.tier).now) / 100 });
      /* v1.6.4: a set picked earlier in this session is replaced, not stacked —
         any line this lander added before (properties._ov_lp = air-*) is
         zeroed first. Costs one extra request only when such lines exist. */
      var ready = cartSnap ? Promise.resolve(cartSnap) : snapCart();
      ready.then(function (cart) {
        var stale = {};
        ((cart && cart.items) || []).forEach(function (it) {
          var lp = (it.properties || {})._ov_lp || '';
          if (lp.indexOf('air-') === 0 && it.key) stale[it.key] = 0;
        });
        if (!Object.keys(stale).length) return null;
        return post(rootUrl + 'cart/update.js', { updates: stale }).then(function (c) { cartSnap = c; return c; });
      })
        .then(function () { return post(rootUrl + 'cart/add.js', { items: items }); })
        .then(function (added) {
          /* v1.4: no theme-side AddToCart / add_to_cart here. Shopify's channel
             pixels report the add from the standard product_added_to_cart event. */
          document.dispatchEvent(new CustomEvent('ovo:added', { detail: { tier: state.tier, cart: added } }));
          if (cfg.checkout) {
            /* v1.6.2: straight to checkout with the code on the URL — no read-back,
               no update call. Codes come from the load-time snapshot plus this tier. */
            var codes = codesFor(cartSnap && { discount_codes: cartSnap.discount_codes, items: [] });
            want.forEach(function (c) { if (codes.indexOf(c) < 0) codes.push(c); });
            /* v1.6.3: the /discount/ link route takes several codes (comma list)
               and sets the discount cookie, then redirects into checkout; the
               ?discount= checkout param only honours one code. */
            location.href = codes.length
              ? rootUrl + 'discount/' + encodeURIComponent(codes.join(',')) + '?redirect=' + encodeURIComponent(rootUrl + 'checkout')
              : rootUrl + 'checkout';
            return null;
          }
          return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          var codes = codesFor(cart);
          want.forEach(function (c) { if (codes.indexOf(c) < 0) codes.push(c); });
          return post(rootUrl + 'cart/update.js', { discount: codes.join(','), sections: sections.join(','), sections_url: location.pathname });
        })
        .then(function (cart) {
          if (!cart) return;
          state.busy = false; renderPrices();
          if (drawer && typeof drawer.renderContents === 'function' && cart.sections) {
            cart.id = av.id;
            drawer.classList.remove('is-empty');
            drawer.renderContents(cart);
          } else {
            location.href = rootUrl + 'cart';
          }
          try {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ovelle-air-offer', cartData: cart });
            }
          } catch (e) {}
        })
        .catch(function (e) {
          state.busy = false; state.going = false; renderPrices();
          track('ovo_checkout_error', { tier: state.tier, message: String((e && e.message) || 'unknown').slice(0, 90) });
          errEl.textContent = e.message || 'Something went wrong. Please try again.';
          errEl.hidden = false;
        });
    }
    addBtn.addEventListener('click', add);
    /* v1.6.3: Back from checkout restores the page from the bfcache with the
       button still in its 'Opening checkout…' state. Reset it and re-read the bag. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted && !state.going) return;
      state.busy = false; state.going = false; renderPrices(); snapCart();
    });

    /* ---------- countdown ---------- */
    var over = false;
    var ends = cfg.ends ? Date.parse(cfg.ends) : NaN;
    /* v2.6 (2 Nov 2026, Marc): rolling deadline. Once "Offer ends" passes, the clock restarts
       in 2-day steps from that time (03:59:59Z → 2 days later → …), so the sale never shows
       "Offer ended" and every visitor sees the same countdown. Set ROLL to 0 to stop rolling. */
    var ROLL = 2 * 864e5;
    function rollEnds() { if (!isNaN(ends) && ROLL > 0 && ends <= Date.now()) ends += Math.ceil((Date.now() - ends + 1) / ROLL) * ROLL; }
    rollEnds();
    var heroTimer = root.querySelector('.ovo-timer');
    var counters = [].slice.call(root.querySelectorAll('[data-ovo-count]'));
    function tick() {
      if (isNaN(ends)) return;
      rollEnds();
      var left = Math.max(0, ends - Date.now());
      var wasOver = over;
      over = left <= 0;
      var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, mi = Math.floor(left / 6e4) % 60, se = Math.floor(left / 1e3) % 60;
      counters.forEach(function (el) {
        var dd = el.querySelector('[data-d]');
        if (dd) {
          dd.textContent = pad(d); el.querySelector('[data-h]').textContent = pad(h);
          el.querySelector('[data-m]').textContent = pad(mi); el.querySelector('[data-s]').textContent = pad(se);
        } else {
          el.textContent = over ? 'ended' : (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(mi) + ':' + pad(se);
        }
      });
      if (heroTimer) heroTimer.classList.toggle('is-over', over);
      var urgBar = root.querySelector('[data-ovo-urg]');
      if (urgBar) urgBar.classList.toggle('is-over', over);
      if (deadlineEl) deadlineEl.textContent = over ? 'This offer has ended.' : (d > 0 ? 'Offer ends in ' + d + ' day' + (d === 1 ? '' : 's') + ' ' + pad(h) + ':' + pad(mi) + ':' + pad(se) : 'Offer ends in ' + pad(h) + ':' + pad(mi) + ':' + pad(se));
      if (over !== wasOver) renderPrices();
    }
    setInterval(tick, 1000);

    /* ---------- sticky bar + countdown strip ---------- */
    var sticky = root.querySelector('[data-ovo-sticky]');
    var stickyName = root.querySelector('[data-ovo-sticky-name]');
    var stickyPrice = root.querySelector('[data-ovo-sticky-price]');
    var stickyAdd = root.querySelector('[data-ovo-sticky-add]');
    var strip = root.querySelector('[data-ovo-strip]');
    var stripPrice = root.querySelector('[data-ovo-strip-price]');
    var ctaWrap = root.querySelector('[data-ovo-cta-wrap]');
    var heroCta = root.querySelector('[data-ovo-hero-cta]');
    var offers = root.querySelector('#ovo-offers');
    var finalSec = root.querySelector('.ovo-final');
    var heroEl = root.querySelector('[data-ovo-hero]');
    stickyAdd.addEventListener('click', function () { offers.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    root.querySelectorAll('[data-ovo-jump]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); offers.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });
    var ctaVisible = true, offersVisible = true, finalVisible = false, heroCtaVisible = true;
    function updateBars() {
      var showStrip = !heroCtaVisible && !finalVisible;
      strip.classList.toggle('is-shown', showStrip);
      var showSticky = showStrip && !ctaVisible && !offersVisible;
      sticky.classList.toggle('is-shown', showSticky);
      strip.classList.toggle('is-behind', proof && showSticky);
      sticky.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
      stickyAdd.tabIndex = showSticky ? 0 : -1;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { heroCtaVisible = e.isIntersecting; }); updateBars(); }).observe(heroEl || heroCta);
      new IntersectionObserver(function (es) { es.forEach(function (e) { ctaVisible = e.isIntersecting; }); updateBars(); }).observe(ctaWrap);
      new IntersectionObserver(function (es) { es.forEach(function (e) { offersVisible = e.isIntersecting; }); updateBars(); }, { rootMargin: '0px 0px -40% 0px' }).observe(offers);
      if (finalSec) new IntersectionObserver(function (es) { es.forEach(function (e) { finalVisible = e.isIntersecting; }); updateBars(); }).observe(finalSec);
    }

    /* ---------- v2.1: urgency bar sits right under the store header while it is showing ---------- */
    (function () {
      var bar = root.querySelector('[data-ovo-urg]');
      if (!bar) return;
      var hdr = document.querySelector('.section-header') || document.querySelector('sticky-header');
      var until = 0, ticking = false;
      function place() {
        var t = 0;
        if (hdr) { var r = hdr.getBoundingClientRect(); t = Math.max(0, Math.round(r.bottom)); }
        bar.style.top = t + 'px';
      }
      function loop() { place(); if (Date.now() < until) requestAnimationFrame(loop); else ticking = false; }
      function kick() { until = Date.now() + 450; if (!ticking) { ticking = true; requestAnimationFrame(loop); } }
      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick);
      /* v2.2: the header changes height after first paint (announcement bar, fonts, logo).
         A stale top pushed the sticky bar down, leaving a gap under the header and covering the hero badge. */
      window.addEventListener('load', kick);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(kick);
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(kick);
        if (hdr) ro.observe(hdr);
        var ann = document.querySelector('.announcement-bar-section, .shopify-section-group-header-group');
        if (ann && ann !== hdr) ro.observe(ann);
      }
      place();
      kick();
    })();

    /* ---------- v1.9: selling-point carousel in the dark offer bar ---------- */
    (function () {
      var wrap = root.querySelector('.ovo-daily--rot');
      if (!wrap) return;
      var dots = wrap.querySelector('[data-ovo-daily-dots]'), idx = 0, paused = false;
      function slides() { return [].slice.call(wrap.querySelectorAll('.ovo-daily__slide')).filter(function (el) { return !el.hidden; }); }
      function show(n) {
        var ss = slides(); if (!ss.length) return;
        idx = (n + ss.length) % ss.length;
        ss.forEach(function (el, k) { el.classList.toggle('is-on', k === idx); });
        if (dots) dots.innerHTML = ss.map(function (_, k) { return '<i' + (k === idx ? ' class="is-on"' : '') + '></i>'; }).join('');
      }
      setTimeout(function () { show(0); }, 60);
      wrap.addEventListener('click', function () { show(idx + 1); });
      if (reduce) return;
      wrap.addEventListener('mouseenter', function () { paused = true; });
      wrap.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () { if (!paused && !document.hidden) show(idx + 1); }, 4200);
    })();

    /* ---------- UGC carousel ---------- */
    var ugcCards = [].slice.call(root.querySelectorAll('[data-ovo-ugc-card]'));
    var ugcRow = root.querySelector('[data-ovo-ugc-row]');
    function stopAll(except) {
      ugcCards.forEach(function (c) {
        if (c === except) return;
        /* v1.5: a muted autoplaying card keeps going; a loud one drops back to muted */
        if (c.classList.contains('is-auto')) {
          if (c.classList.contains('is-loud') && c.__ovoAuto) { c.__ovoAuto.stop(); c.__ovoAuto.play(); }
          return;
        }
        var v = c.querySelector('video');
        if (v && !v.paused) v.pause();
        c.classList.remove('is-playing', 'is-paused');
        var mu = c.querySelector('[data-ovo-ugc-mute]'); if (mu) mu.hidden = true;
      });
    }
    var ugcIdx = function (c) { return ugcCards.indexOf(c) + 1; };
    ugcCards.forEach(function (c) {
      var v = c.querySelector('video'); var p = c.querySelector('[data-ovo-ugc-play]'); var mu = c.querySelector('[data-ovo-ugc-mute]');
      if (!v || !p) return;
      var auto = proof && v.hasAttribute('data-ovo-autoplay') && !reduce;
      var started = false, done = false;
      v.addEventListener('timeupdate', function () {
        if (v.duration) c.style.setProperty('--ovo-prog', (v.currentTime / v.duration * 100).toFixed(1) + '%');
        if (!done && v.duration && v.currentTime / v.duration > 0.95) { done = true; track('ovo_video', { action: 'complete', video: ugcIdx(c), loud: !v.muted }); }
      });
      function play() {
        stopAll(c);
        /* v1.4: the poster is only attached once someone plays, so six full-size
           frames are not downloaded on page load (the lazy <img> shows the same frame). */
        if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster;
        v.muted = false; v.loop = false;
        if (auto) { v.currentTime = 0; c.classList.add('is-loud'); }
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () { v.muted = true; mu.classList.add('is-muted'); v.play().catch(function () {}); });
        c.classList.add('is-playing'); c.classList.remove('is-paused');
        mu.hidden = false;
        if (!started) { started = true; track('ovo_video', { action: 'start', video: ugcIdx(c), loud: true }); }
        if (ugcRow) c.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      function pause() { v.pause(); c.classList.add('is-paused'); }
      /* v1.5: muted autoplay while the card is in view (proof flow) */
      function autoPlay() {
        if (!auto || c.classList.contains('is-loud') || c.classList.contains('is-paused')) return;
        if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster;
        v.muted = true; v.loop = true;
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
        c.classList.add('is-playing', 'is-auto');
      }
      function autoStop() {
        if (!auto) return;
        v.pause();
        c.classList.remove('is-playing', 'is-auto', 'is-loud', 'is-paused');
        v.muted = true; v.loop = true; mu.hidden = true; mu.classList.remove('is-muted');
      }
      c.__ovoAuto = { play: autoPlay, stop: autoStop };
      var snd = c.querySelector('[data-ovo-ugc-sound]');
      if (snd) snd.addEventListener('click', function (e) { e.stopPropagation(); play(); });
      p.addEventListener('click', function () { if (c.classList.contains('is-playing') && !v.paused) pause(); else play(); });
      v.addEventListener('click', function () {
        if (auto && c.classList.contains('is-auto') && !c.classList.contains('is-loud')) { play(); return; }
        if (v.paused) play(); else pause();
      });
      v.addEventListener('ended', function () { if (v.loop) return; c.classList.remove('is-playing', 'is-paused', 'is-loud'); mu.hidden = true; v.currentTime = 0; if (auto) { c.classList.remove('is-auto'); autoPlay(); } });
      mu.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; mu.classList.toggle('is-muted', v.muted); mu.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute'); });
    });
    if (ugcRow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var c = e.target, v = c.querySelector('video');
          if (e.isIntersecting) { if (c.__ovoAuto) c.__ovoAuto.play(); return; }
          if (c.__ovoAuto && c.classList.contains('is-auto')) { c.__ovoAuto.stop(); return; }
          if (v && !v.paused) { v.pause(); c.classList.add('is-paused'); }
        });
      }, { threshold: proof ? 0.6 : 0.35 });
      ugcCards.forEach(function (c) { io.observe(c); });
    }
    var prev = root.querySelector('[data-ovo-ugc-prev]'), next = root.querySelector('[data-ovo-ugc-next]');
    function step(dir) { if (!ugcRow) return; var w = (ugcCards[0] ? ugcCards[0].getBoundingClientRect().width : 240) + 12; ugcRow.scrollBy({ left: dir * w * 2, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* ---------- in-real-homes photo row arrows ---------- */
    var homesRow = root.querySelector('[data-ovo-homes-row]');
    var hPrev = root.querySelector('[data-ovo-homes-prev]'), hNext = root.querySelector('[data-ovo-homes-next]');
    function hStep(dir) { if (!homesRow) return; var c = homesRow.firstElementChild; var w = (c ? c.getBoundingClientRect().width : 240) + 12; homesRow.scrollBy({ left: dir * w * 2, behavior: 'smooth' }); }
    if (hPrev) hPrev.addEventListener('click', function () { hStep(-1); });
    if (hNext) hNext.addEventListener('click', function () { hStep(1); });

    function renderAll() { renderColors(); renderScents(); renderPrices(); }
    /* v2.5: read-only handle for the kit builder (flow = kit). */
    root.__ovoApi = { state: state, cfg: cfg, quote: quote, count: count, chosen: chosen, missing: missing, oilById: oilById, oils: oils,
      selectTier: selectTier, airVariant: airVariant, isRefillSlot: isRefillSlot, shipText: shipText, NAMES: NAMES, m: m, track: track,
      isOver: function () { return over; }, add: add };
    renderAll();
    tick();
    updateBars();
  }

  function boot() { document.querySelectorAll('[data-ovo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
